import { createStackNavigator } from "@react-navigation/stack";
import { useIntl } from "react-intl";
import { SCREENS } from "navigation/consts";
import EventDetails from "views/EventDetails";
import TicketList from "views/TicketList";
import Cart from "views/Cart";
import OrderProvider from "providers/OrderProvider";
import Billing from "views/Billing";
import Checkout from "views/Checkout";
import Payment from "views/Payment";
import OrderDetails from "views/OrderDetails";

import { EventNavigationParamList } from "./types";

const { Navigator, Screen } = createStackNavigator<EventNavigationParamList>();

const EventNavigation: React.FC = () => {
  const intl = useIntl();

  return (
    <OrderProvider>
      <Navigator screenOptions={{ headerTitleAlign: "center" }}>
        <Screen
          name={SCREENS.EventDetails}
          component={EventDetails}
          options={{ title: intl.formatMessage({ defaultMessage: "Event" }) }}
        />
        <Screen
          name={SCREENS.TicketList}
          component={TicketList}
          options={{ title: intl.formatMessage({ defaultMessage: "Tickets" }) }}
        />
        <Screen
          name={SCREENS.Cart}
          component={Cart}
          options={{ title: intl.formatMessage({ defaultMessage: "Cart" }) }}
        />
        <Screen
          name={SCREENS.Billing}
          component={Billing}
          options={{ title: intl.formatMessage({ defaultMessage: "Billing" }) }}
        />
        <Screen
          name={SCREENS.Checkout}
          component={Checkout}
          options={{
            title: intl.formatMessage({ defaultMessage: "Checkout" }),
          }}
        />
        <Screen
          name={SCREENS.Payment}
          component={Payment}
          options={{
            title: intl.formatMessage({ defaultMessage: "Payment" }),
          }}
        />
        <Screen
          name={SCREENS.OrderDetails}
          component={OrderDetails}
          options={{
            title: intl.formatMessage({ defaultMessage: "Order" }),
          }}
        />
      </Navigator>
    </OrderProvider>
  );
};

export default EventNavigation;
